import { CREATE, LIST } from "./actionsTypes";
import { formatMeta2Frontend } from "./utils";

const initialState = {
    isLoading: false,
    locations: [],
    current: null,
    filter: { search: "", limit: 50, ordering: "" },
    // Note: layers, allocatedLayersPerDay, checks, registerData, todayRegisterData
    // are no longer stored in Redux - handled by TanStack Query in ripening room
};

export default (state = initialState, action) => {
    switch (action.type) {
    case LIST.LOADING:
        return { ...state, isLoading: true };
    case LIST.SUCCESS:
        return { ...state, isLoading: false, locations: action.payload.data.map(formatMeta2Frontend) };
    case LIST.ERROR:
        return { ...state, isLoading: false };
    case LIST.FILTER:
        return { ...state, filter: action.payload };
    case CREATE.LOADING:
        return { ...state, isLoading: true };
    case CREATE.SUCCESS:
        return { ...state, isLoading: false };
    case CREATE.ERROR:
        return { ...state, isLoading: false };
    // Note: PATCH actions are no longer used - replaced by TanStack Query mutations
    // Note: GET, GET_LAYERS, GET_CHECKS, GET_REGISTER_DATA, GET_TODAY_REGISTER_DATA actions
    // are no longer used in the ripening room - replaced by TanStack Query hooks
    default:
        return state;
    }
};
